module.exports = __webpack_public_path__ + "static/media/principal.70966077.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/ser/principal.jpg
 ** module id = 158
 ** module chunks = 0
 **/